import { parseFeatureFlags } from '@airasia-common/libraries/featureFlag';
import { handleActions } from 'redux-actions';
import { SchHotelConfig, getSchHotelConfig } from '../../constants';
import { types } from './metadata.meta';

export const initialState = {
  countries: [],
  stations: [],
  featureFlags: parseFeatureFlags({}),
  hotelConfig: [],
  supportedCurrencies: [],
  isFetching: false,
  isFetchingFeatureFlags: true,
  isFetchingHotelConfig: true,
  hotelTranslations: [],
};

export const fetchCountries = state => ({
  ...state,
  isFetching: true,
});

export const fetchCountriesCompleted = (state, action) => {
  const { countries } = action.payload;
  return {
    ...state,
    countries,
    isFetching: false,
  };
};

export const fetchStations = state => ({
  ...state,
  isFetching: true,
});

export const fetchStationsCompleted = (state, action) => {
  return {
    ...state,
    stations: action.payload,
    isFetching: false,
  };
};

export const fetchHotelFeatureFlags = state => ({
  ...state,
  isFetchingFeatureFlags: true,
});

export const fetchHotelFeatureFlagsCompleted = (state, action) => ({
  ...state,
  featureFlags: parseFeatureFlags(action.payload?.configuration),
  isFetchingFeatureFlags: false,
});

export const fetchHotelFeatureFlagsFailed = state => ({
  ...state,
  featureFlags: parseFeatureFlags({}),
  isFetchingFeatureFlags: false,
});

export const fetchHotelConfig = state => ({
  ...state,
  isFetchingHotelConfig: true,
});

export const fetchHotelConfigCompleted = (state, { payload }) => {
  return {
    ...state,
    hotelConfig: getSchHotelConfig(payload?.currencies),
    isFetchingHotelConfig: false,
  };
};

export const fetchHotelConfigFailed = state => ({
  ...state,
  hotelConfig: [],
  isFetchingHotelConfig: false,
});

export const fetchHeaderCurrencies = state => ({
  ...state,
  supportedCurrencies: [],
});

export const fetchHeaderCurrenciesCompleted = (state, { payload }) => ({
  ...state,
  supportedCurrencies: Object.keys(payload?.currency).sort(),
});

export const fetchHeaderCurrenciesFailed = state => ({
  ...state,
  supportedCurrencies: [],
});

export const fetchReverseGeoLocation = state => ({
  ...state,
  fetchingReverseGeoLocation: true,
});

export const fetchReverseGeoLocationCompleted = (state, { payload }) => {
  const lst = payload?.results?.reduce((addressComponents, result) => {
    const addresses = result?.address_components?.filter(
      item => item?.types?.filter(type => type === 'country').length > 0
    );
    addresses && addressComponents.push(addresses);
    return addressComponents;
  }, []);
  return {
    ...state,
    reverseGeoLocation: lst?.[0]?.[0],
    fetchingReverseGeoLocation: false,
  };
};

export const fetchReverseGeoLocationFailed = state => ({
  ...state,
  fetchingReverseGeoLocation: false,
});

export const fetchUHFData = state => ({
  ...state,
  uhfData: false,
  isFetchingUHFData: true,
});
export const fetchUHFDataCompleted = (state, { payload }) => {
  const { headerData = {} } = payload;
  // GET supportedCurrencies
  const currencies = headerData.currencyList || [];
  const currenciesData = currencies.length ? currencies[0].data : [];
  const supportedCurrencies = [];
  currenciesData.forEach(e => {
    supportedCurrencies.push(e.shortform);
  });
  return {
    ...state,
    uhfData: payload,
    isFetchingUHFData: false,
    supportedCurrencies: supportedCurrencies.sort(),
  };
};
export const fetchUHFDataFailed = state => ({
  ...state,
  uhfData: false,
  isFetchingUHFData: false,
});

export const fetchUHSWData = state => ({
  ...state,
  uhswData: false,
  isFetchingUHSWData: true,
});

export const fetchUHSWDataCompleted = (state, { payload }) => {
  return {
    ...state,
    uhswData: payload,
    isFetchingUHSWData: false,
  };
};

export const fetchUHSWDataFailed = state => ({
  ...state,
  uhswData: false,
  isFetchingUHSWData: false,
});

export const fetchPopupData = state => ({
  ...state,
  popupData: false,
  isFetchingPopupData: true,
});

export const fetchPopupDataCompleted = (state, { payload }) => {
  return {
    ...state,
    popupData: payload,
    isFetchingPopupData: false,
  };
};

export const fetchPopupDataFailed = state => ({
  ...state,
  popupData: false,
  isFetchingPopupData: false,
});

export const fetchHotelTranslationsCompleted = (state, { payload }) => ({
  ...state,
  hotelTranslations: payload,
});

export const fetchHotelTranslationsFailed = state => ({
  ...state,
  hotelTranslations: [],
});

export default handleActions(
  {
    [types.FETCH_COUNTRIES]: fetchCountries,
    [types.FETCH_COUNTRIES_COMPLETED]: fetchCountriesCompleted,
    [types.FETCH_STATIONS]: fetchStations,
    [types.FETCH_STATIONS_COMPLETED]: fetchStationsCompleted,
    [types.FETCH_HOTEL_FEATURE_FLAGS]: fetchHotelFeatureFlags,
    [types.FETCH_HOTEL_FEATURE_FLAGS_COMPLETED]: fetchHotelFeatureFlagsCompleted,
    [types.FETCH_HOTEL_FEATURE_FLAGS_FAILED]: fetchHotelFeatureFlagsFailed,
    [types.FETCH_HOTEL_CONFIG]: fetchHotelConfig,
    [types.FETCH_HOTEL_CONFIG_COMPLETED]: fetchHotelConfigCompleted,
    [types.FETCH_HOTEL_CONFIG_FAILED]: fetchHotelConfigFailed,
    [types.FETCH_HEADER_CURRENCIES]: fetchHeaderCurrencies,
    [types.FETCH_HEADER_CURRENCIES_COMPLETED]: fetchHeaderCurrenciesCompleted,
    [types.FETCH_HEADER_CURRENCIES_FAILED]: fetchHeaderCurrenciesFailed,
    [types.FETCH_REVERSE_GEO_LOCATION]: fetchReverseGeoLocation,
    [types.FETCH_REVERSE_GEO_LOCATION_COMPLETED]: fetchReverseGeoLocationCompleted,
    [types.FETCH_REVERSE_GEO_LOCATION_FAILED]: fetchReverseGeoLocationFailed,
    [types.FETCH_UHF_DATA]: fetchUHFData,
    [types.FETCH_UHF_DATA_COMPLETED]: fetchUHFDataCompleted,
    [types.FETCH_UHF_DATA_FAILED]: fetchUHFDataFailed,
    [types.FETCH_UHSW_DATA]: fetchUHSWData,
    [types.FETCH_UHSW_DATA_COMPLETED]: fetchUHSWDataCompleted,
    [types.FETCH_UHSW_DATA_FAILED]: fetchUHSWDataFailed,
    [types.FETCH_POPUP_DATA]: fetchPopupData,
    [types.FETCH_POPUP_DATA_COMPLETED]: fetchPopupDataCompleted,
    [types.FETCH_POPUP_DATA_FAILED]: fetchPopupDataFailed,
    [types.FETCH_HOTEL_TRANSLATIONS_COMPLETED]: fetchHotelTranslationsCompleted,
    [types.FETCH_HOTEL_TRANSLATIONS_FAILED]: fetchHotelTranslationsFailed,
  },
  initialState
);
